import React, { useState } from 'react';
import { PlansManager } from '../components/billing/PlansManager';
import { InvoicesList } from '../components/billing/InvoicesList';
import { useI18n } from '../contexts/I18nContext';
import '../components/billing/Billing.css';

export const Billing: React.FC = () => {
  const { t } = useI18n();
  const [activeTab, setActiveTab] = useState<'plans' | 'invoices'>('plans');

  return (
    <div className="billing-page">
      <header className="billing-page-header">
        <div className="billing-page-title">
          <h1>{t('billing.title')}</h1>
          <p className="billing-page-subtitle">{t('billing.subtitle')}</p>
        </div>
        <nav className="billing-tabs" aria-label={t('billing.tabs.aria')}>
          <button
            type="button"
            className={`billing-tab ${activeTab === 'plans' ? 'active' : ''}`}
            onClick={() => setActiveTab('plans')}
            aria-selected={activeTab === 'plans'}
          >
            {t('billing.tabs.plans')}
          </button>
          <button
            type="button"
            className={`billing-tab ${activeTab === 'invoices' ? 'active' : ''}`}
            onClick={() => setActiveTab('invoices')}
            aria-selected={activeTab === 'invoices'}
          >
            {t('billing.tabs.invoices')}
          </button>
        </nav>
      </header>

      <div className="billing-content">
        {activeTab === 'plans' && <PlansManager />}
        {activeTab === 'invoices' && <InvoicesList />}
      </div>
    </div>
  );
};

